<template> 
  <div> 
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="6" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" variant="outline-secondary">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ totalData }} Entries</small>
            </h5>
          </b-col>
          <b-col md="4">
            <b-button class="pull-right ml-1 mt-1" :variant="Filter.job_no ||
              Filter.commonFilter ||
              Filter.clientFilter ||
              Filter.airLineFilter ||
              Filter.airportDepartureFilter ||
              Filter.airportDestinationFilter ||
              Filter.transportFilter ||
              Filter.jobTypeFilter ||
              Filter.createdByFilter ||
              Filter.isShipmentFilter ||
              Filter.isActiveFilter ||
              Filter.isDeletedFilter ||
              Filter.dateRange.startDate ||
              Filter.dateRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.job_no ||
                  Filter.commonFilter ||
                  Filter.clientFilter ||
                  Filter.airLineFilter ||
                  Filter.airportDepartureFilter ||
                  Filter.airportDestinationFilter ||
                  Filter.transportFilter ||
                  Filter.jobTypeFilter ||
                  Filter.createdByFilter ||
                  Filter.isShipmentFilter ||
                  Filter.isActiveFilter ||
                  Filter.isDeletedFilter ||
                  Filter.dateRange.startDate ||
                  Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>
            <b-button class="pull-right ml-1 mt-1" v-if="getAirList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getAirList', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>
          </b-col>

          <b-col cols="12">
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </b-col>
        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
                    :endDate="endDate" :locale-data="locale" :disabled="Filter.DFlag ? true : false"
                    @update="getAllTPTCCAirList('Normal', '0', '0', '1', '1')"></date-range-picker>
                </b-col>
                <b-col md="3">
                  <label>Client</label>

                  <model-list-select :list="$store.getters['common/getAllClientList']" id="clientNamenew"
                    v-model="Filter.clientFilter" option-value="clientId" option-text="clientName"
                    placeholder="Select Client Name"
                    @input="getAllTPTCCAirList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>AirLine</label>

                  <model-list-select :list="$store.getters['common/getAllAirLineList']" v-model="Filter.airLineFilter"
                    option-value="airlineId" option-text="airlineName" placeholder="Select Air Line"
                    @input="getAllTPTCCAirList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Departure</label>
                  <model-list-select :list="$store.getters['common/getAllAirPortDepartureList']"
                    v-model="Filter.airportDepartureFilter" option-value="pickupId" option-text="pickupLocation"
                    placeholder="Select Airport of Departure"
                    @input="getAllTPTCCAirList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Destination</label>

                  <model-list-select :list="$store.getters['common/getAllAirPortDestinationList']"
                    v-model="Filter.airportDestinationFilter" option-value="pickupId" option-text="pickupLocation"
                    placeholder="Select Airport of Destination"
                    @input="getAllTPTCCAirList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Transport Type</label>

                  <model-list-select :list="TransportTypeList" v-model="Filter.transportFilter" option-value="DVal"
                    option-text="DText" placeholder="Select"
                    @input="getAllTPTCCAirList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Job Type</label>

                  <model-list-select :list="JobTypeList" v-model="Filter.jobTypeFilter" option-value="DVal"
                    option-text="DText" placeholder="Select"
                    @input="getAllTPTCCAirList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>

                <b-col md="3">
                  <label>Job No Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Job No Filter" id="job_no"
                    name="job_no" autocomplete="off" v-model="Filter.job_no"
                    @input="getAllTPTCCAirList('Normal', '0', '0', '1', '1')"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Common</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Subject Filter"
                    id="commonFilter" name="commonFilter" autocomplete="off" v-model="Filter.commonFilter"
                    @input="getAllTPTCCAirList('Normal', '0', '0', '1', '1')"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>
                    <b> Created User </b>
                  </label>
                  <model-list-select :list="$store.getters['common/getAllUserList']" id="createdByFilter"
                    @input="getAllTPTCCAirList('Normal', '0', '0', '1', '1')" v-model="Filter.createdByFilter"
                    option-value="userId" option-text="employeeName"
                    placeholder="Select Created User"></model-list-select>
                </b-col>
                <b-col md="12" class="mt-2">
                  <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                    variant="outline-danger">Reset</b-button>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive tableMain gutr">
              <b-table show-empty stacked="md" responsive :items="getAirList" :fields="JobsFields"
                primary-key="id_email_section" :per-page="pagination.perPage" :filter="filter" :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"
                class="position-relative">
                <template slot="SN" slot-scope="row0">
                  <span>{{
                    row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                  }}</span>
                </template>

                <template slot="JobNo" slot-scope="row1">
                  <span><a href="#" class="job-no" @click.prevent="
                    row1.item.is_locked == '1' &&
                      (row1.item.finalBillingCompleted == 1 ||
                        row1.item.locked_counter > 0) &&
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                      ? ''
                      : handleJobClick(row1.item.JobNo, row1.item)">
                      <b>Job No: </b>{{ row1.item.JobNo }}
                    </a></span><br />
                  <span><b>Job Date : </b>{{ row1.item.created_at }}</span><br />
                  <span><b>Job Type : </b>{{ row1.item.air_ct_job_type }}</span><br />
                  <span><b>Transport Type : </b>{{ row1.item.air_ct_transport_type }}</span><br />
                  <span><b>Shipment Type : </b>{{ row1.item.air_ct_shipment_type_Txt }}</span><br />
                  <span><b>Enq No : </b>{{ row1.item.EnqNo }}</span><br />
                  <span><b>Enq Date : </b>{{ row1.item.EnqDate }}</span><br />
                  <span><b>Booking No : </b>{{ row1.item.booking_no }}</span><br />
                  <span><b>Raised By : </b>{{ row1.item.CreatedBy }}</span><br />
                  <span><b>Raised From : </b>{{ row1.item.RaisedBy }}</span>

                  <b-button
                  style="font-size: 0.675rem"
                  class="mt-2"
                  size="sm"
                  @click="
                    row1.item.is_locked == '1' &&
                    (row1.item.air_ct_main_sales_execution_relation.finalBillingCompleted == 1 || row1.item.locked_counter > 0)
                      ? LockUnLock(row1.item, 'locked')
                      : ''
                  "
                  :variant="
                    row1.item.is_locked == '1' &&
                    (row1.item.air_ct_main_sales_execution_relation.finalBillingCompleted == 1 || row1.item.locked_counter > 0)
                      ? 'danger'
                      : 'success'
                  "
                  ><b
                    v-if="
                      row1.item.is_locked == '1' &&
                      (row1.item.air_ct_main_sales_execution_relation.finalBillingCompleted == 1 ||
                        row1.item.locked_counter > 0)
                    "
                    ><i class="fa fa-lock mr-1 lg"></i>LOCKED</b
                  ><b v-else><i class="fa fa-unlock mr-1 lg"></i>UN-LOCKED</b></b-button
                ><br />
                <b-button
                  class="mt-2"
                  style="font-size: 0.675rem"
                  size="sm"
                  @click="showDocModal(row1.item)"
                  variant="outline-info"
                  >Summary & Documents</b-button
                >
                <Overseas-CRDRNote
                  :title="row1.item.JobNo"
                  :moduleType="'Air ' + row1.item.air_ct_transport_type + ' Module'"
                  :cr_all_module_id="String(row1.item.fk_all_module_id)"
                  :cr_jb_series="row1.item.JobNo"
                  :cr_ass_date="row1.item.loginTime"
                  :transportType="row1.item.air_ct_transport_type"
                  :Jobtype="$route.path=='/airImport/viewAirCC'?'CC':'TPT'"
                  :commonId="String(row1.item.air_ct_id)"
                  :shipmentType="row1.item.air_ct_shipment_type=='2'?'Air':'Sea'"
                  :isOverseas="false"
                  :ItemAr="null"
                />
                <Assignment-Summary
                  :title="'Shipment Summary Tracking - '"
                  :fk_all_module_id="row1.item.fk_all_module_id"
                  :jb_series="row1.item.JobNo"
                />
                <ContainerSummary
                v-if="row1.item.fk_all_module_id"
                :PMC_title="'Container Summary Job No - ' + row1.item.JobNo"
                :PMC_JOBID="row1.item.fk_all_module_id.toString()"
                :PMC_JOBNO="row1.item.JobNo"
                :PMC_JOBDATE="''"
                :PMC_JOBTYPE="''"
                :PMC_AgentType="''"
                :PMC_Client="''"
                :PMC_Sline="''"
              />
              <!-- <JobWisePaymentsDetails
                  v-if="row1.item.fk_all_module_id"
                  :allModuleId="Number(row1.item.fk_all_module_id)"
                  :JobNo="row1.item.JobNo"
                  /> -->
              <RejectInvTallyBillSummary
                v-if="row1.item.fk_all_module_id"
                :PMC_title="'Invoice Rejection Log Summary Job No - ' + row1.item.JobNo"
                :PMC_JOBID="row1.item.fk_all_module_id.toString()"
                :PMC_JOBNO="row1.item.JobNo"
                :PMC_JOBDATE="''"
                :PMC_JOBTYPE="''"
                :PMC_Client="''"
                :PMC_Sline="''"
              />

                </template>
                <template slot="ClientName" slot-scope="row5">
                  <span><b>Client : </b>{{ row5.item.ClientName }}</span><br />
                  <span><b>Exp Client : </b>{{ row5.item.ExpClientName }}</span><br />
                  <span><b>Imp Client : </b>{{ row5.item.ImpClientName }}</span><br />
                  <span><b>Airline : </b>{{ row5.item.Airline }}</span><br />
                </template>
                <template slot="Departure" slot-scope="row5">
                  <span><b>Departure : </b>{{ row5.item.Departure }}</span><br />
                  <span><b>Destination : </b>{{ row5.item.Destination }}</span>
                </template>
                <template slot="air_ct_flight_no" slot-scope="row5">
                  <span><b>Flight No : </b>{{ row5.item.air_ct_flight_no }}</span><br />
                  <span><b>Flight Date : </b>{{ row5.item.FlightDate }}</span><br />
                  <span><b>Bl Type : </b>{{ row5.item.air_ct_bl_type }}</span><br />
                  <span><b>MAWB/Bl No : </b>{{ row5.item.air_ct_mawb_bl_number }}</span><br />
                  <span><b>MAWB/Bl Date : </b>{{ row5.item.MAWBDate }}</span><br />
                  <span><b>AWB/Bl No : </b>{{ row5.item.air_ct_awb_bl_number }}</span><br />
                  <span><b>AWB/Bl Date : </b>{{ row5.item.AWBDate }}</span>
                </template>
                <template slot="air_ct_shipping_bl_no" slot-scope="row5">
                  <span><b>Shipping Bl No : </b>{{ row5.item.air_ct_shipping_bl_no }}</span><br />
                  <span><b>Shipping Bl Date : </b>{{ row5.item.ShippingBLdate }}</span><br />
                  <span><b>Shipping Inv No : </b>{{ row5.item.air_ct_shipper_inv_no }}</span><br />
                  <span><b>Shipping Inv Date : </b>{{ row5.item.ShippingInvdate }}</span><br />
                  <span><b>Clearance Date : </b>{{ row5.item.ClearanceDate }}</span><br />
                  <span><b>Handover date : </b>{{ row5.item.HandDate }}</span><br />
                  <span><b>Booking Date : </b>{{ row5.item.BookingDate }}</span><br />
                  <span><b>Departure Date : </b>{{ row5.item.DepartureDate }}</span><br />
                  <span><b>Arrival Date : </b>{{ row5.item.ArrivalDate }}</span><br />
                  <span><b>Expected Departure Date : </b>{{ row5.item.ExpectedDepartureDate }}</span><br />
                  <span><b>Expected Arrival Date : </b>{{ row5.item.ExpectedArrivalDate }}</span><br />
                  <span><b>Actual Departure Date : </b>{{ row5.item.ActualDepartureDate }}</span><br />
                  <span><b>Actual Arrival Date : </b>{{ row5.item.ActualArrivalDate }}</span>
                </template>
                <template slot="air_ct_cargo_gross_weight" slot-scope="row5">
                  <span><b>Cargo Gross Wgt. : </b>{{ row5.item.air_ct_cargo_gross_weight }}</span><br />
                  <span><b>Cargo Net Wgt. : </b>{{ row5.item.air_ct_cargo_net_weight }}</span><br />
                  <span><b>Volume Wgt. : </b>{{ row5.item.air_ct_cargo_volume_weight }}</span><br />
                  <span><b>Pkg Type : </b>{{ row5.item.air_ct_cargo_pkg_type }}</span><br />
                  <span><b>Unit : </b>{{ row5.item.air_ct_cargo_unit }}</span><br />
                  <span><b>Chargeable Wgt. By Sys : </b>{{ row5.item.air_ct_chargeable_weight_by_sys }}</span><br />
                  <span><b>Chargeable Wgt. By Airline : </b>{{ row5.item.air_ct_chargeable_weight_by_airline
                    }}</span><br />
                  <span><b>Chargeable Wgt. Final : </b>{{ row5.item.air_ct_chargeable_weight_final }}</span><br />
                  <span><b>Total Pkg : </b>{{ row5.item.air_ct_tot_pkg }}</span><br />
                  <span><b>Pkg Length : </b>{{ row5.item.air_ct_length_pkg }}</span><br />
                  <span><b>Pkg Width : </b>{{ row5.item.air_ct_width_pkg }}</span><br />
                  <span><b>Pkg Height : </b>{{ row5.item.air_ct_height_pkg }}</span><br />
                  <span><b>Pkg Unit : </b>{{ row5.item.air_ct_unit_pkg }}</span><br />
                  <span><b>Pkg Volume : </b>{{ row5.item.air_ct_volume_pkg }}</span><br />
                </template>
              </b-table>
            </div>

            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </div>
        </div>

         <!-- Added By Priyanshu Singh For Billing Close Section Start -->
      <b-modal
        id="modal-lock-conf"
        ref="modal-lock-conf"
        title="Reason for Open Locked Assignment"
        centered
        no-close-on-esc
        no-close-on-backdrop
        hide-footer
      >
        <h3>Confirmation</h3>
        <form ref="form">
          <b-form-group
            label="Remark"
            label-for="name-input"
            invalid-feedback="Name is required"
          >
            <b-form-textarea
              :formatter="capitalizeAll"
              rows="5"
              id="name-input"
              v-model="lockReason"
              required
            ></b-form-textarea>
          </b-form-group>
        </form>
        <b-button @click="closeLockUnLockConfirm" variant="danger"> Cancel</b-button>
        <b-button
          v-if="lockReason"
          :disabled="lock_button ? true : false"
          variant="success"
          class="pull-right"
          @click="ConfLock"
          >Send</b-button
        >
      </b-modal>
      <!-- Added By Priyanshu Singh For Billing Close Section End -->
      <b-modal
        size="xl"
        class="modal-dialog-doc"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title=""
      >
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE_DOC } from "../../helper/constant";

import DocForm from "../../component/allModuleForm/docLibrary.vue";
import AddMessage from "../../component/allModuleForm/addMessage.vue";
import AssignmentSummary from "../../component/common/assignmentSummary.vue";
import OverseasCRDRNote from "../common/overseasCRDRNote.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import AssignmentSplitMergeSummary from "../common/AssignmentSplitMergeSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import RejectInvTallyBillSummary from "../common/moduleBasedRejectInvTallyBillSummary.vue";
import MSDeleteRequest from "../common/MSDeleteRequest.vue";
export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    this.getCurrentLastDate();
    this.$store.dispatch(
      "common/setAllUserList",
      JSON.stringify({
        itemCode: "GET_USERLIST_Data",
      })
    );

    this.$store.dispatch(
      "common/setAllAirLineList",
      JSON.stringify({
        itemCode: "AirLineList",
      })
    );
    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList"
      })
    );
    this.$store.dispatch(
      "common/setAllAirPortDepartureList",
      JSON.stringify({
        itemCode: "AirPortDepartureList",
      })
    );
    this.$store.dispatch(
      "common/setAllAirPortDestinationList",
      JSON.stringify({
        itemCode: "AirPortDestinationList",
      })
    );
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
    this.$store.dispatch(
      "common/setAllPORList",
      JSON.stringify({
        itemCode: "PORList",
      })
    );
    this.$store.dispatch(
      "common/setAllPODList",
      JSON.stringify({
        itemCode: "PODList",
        type: "Normal",
        Territory: "",
      })
    );
    this.$store.dispatch(
      "common/setAllLocationDetailsFinalList",
      JSON.stringify({
        itemCode: "LocationDetailsFinalList",
      })
    );
    this.$store.dispatch(
      "common/setAllPOLList",
      JSON.stringify({
        itemCode: "POLList",
      })
    );
    this.$store.dispatch("setCurrentRoute", "/log/email-log");
    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getAllTPTCCAirList("Normal", "0", "0", "1", "1");
    }
  },
  mounted() { },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },
  data() {
    return {

      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      getAirList: [],
      totalData: 0,
      JobsFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "JobNo",
          mainkey: "JobNo",
          label: "Job No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "ClientName",
          mainkey: "ClientName",
          label: "Client/AirLine",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

        {
          key: "Departure",
          mainkey: "Departure",
          label: "Location",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

        {
          key: "air_ct_flight_no",
          mainkey: "air_ct_flight_no",
          label: "Flight/Bl",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "air_ct_shipping_bl_no",
          mainkey: "air_ct_shipping_bl_no",
          label: "Shipping Det.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "air_ct_cargo_gross_weight",
          mainkey: "air_ct_cargo_gross_weight",
          label: "Others",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],
      TransportTypeList: [
        {
          DText: "EXPORT",
          DVal: "Export"
        },
        {
          DText: "Import",
          DVal: "Import"
        },
      ],
      JobTypeList: [
        {
          DText: "EXPORT",
          DVal: "Export"
        },
        {
          DText: "Import",
          DVal: "Import"
        },
      ],

      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,


      Filter: {
        job_no: "",
        commonFilter: "",
        clientFilter: "",
        airLineFilter: "",
        airportDepartureFilter: "",
        airportDestinationFilter: "",
        jobTypeFilter: "",
        clientFilter: "",
        transportFilter: "",
        createdByFilter: "",
        isShipmentFilter: 2,
        isActiveFilter: 1,
        isDeletedFilter: 0,
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      ALLMODULE: "",
      JOBSERIES: "",

      lock_allModuleId: "",
      lock_ffExportFclId: "",
      lock_ffExportFclSeries: "",
      lock_Type: "",
      lockReason: "",
      lock_button: false,
      is_locked: "",
      locked_counter: "",
    };
  },

  components: {
    DocForm,
    AddMessage,
    AssignmentSummary,
    OverseasCRDRNote,
    ContainerSummary,
    AssignmentSplitMergeSummary,
    JobWisePaymentsDetails,
    RejectInvTallyBillSummary,
    MSDeleteRequest,
    CustomLoader,

    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
  },
  computed: {},

  methods: {
    ConfLock() {
      if (this.lockReason) {
        this.isLoading = true;
        let tit = "";
        if (this.is_locked == 1) {
          this.is_locked = "0";
          tit = "Un-Locked";
        } else {
          this.is_locked = "1";
          tit = "Locked";
        }
        this.lock_button = true;
        let payload = {
          allModuleId: this.lock_allModuleId,
          lockReason: this.lockReason,
          update_keyVal: this.lock_ffExportFclId,
          assigmnmentSeries: this.lock_ffExportFclSeries,
          Type: this.lock_Type,
          is_locked: this.is_locked,
          locked_counter: this.locked_counter,
          table_name: "air_cc_tpt_module",
          update_key: "air_ct_id",
          Title: tit,
          module_type: "Air",
        };

        NodeLockPannelService.lockUnLockStatus(payload)
          .then((result) => {
            const { status, data } = result;
            if (status == 200 && data) {
              this.alert.content = data.MSG;
              this.$refs["addPop"].open();
              this.getAllTPTCCAirList("Normal", "0", "0", "1", "1");
              this.lock_button = false;
              this.isLoading = false;
            }
            this.lockReason = "";
            this.$refs["modal-lock-conf"].hide();
          })
          .catch((error) => {
            this.isLoading = false;
            this.lock_button = false;
          });
      }
    },
    LockUnLock(items, type) {
      this.lock_allModuleId = items.fk_all_module_id;
      this.lock_ffExportFclId = items.air_ct_id;
      this.lock_ffExportFclSeries = items.JobNo;
      this.lock_Type = type;
      this.is_locked = items.is_locked;
      this.locked_counter = items.locked_counter;
      console.log("Priyanshu Singh=>", items);
      // return false;
      this.$refs["modal-lock-conf"].show();
    },
    closeLockUnLockConfirm() {
      this.$refs["modal-lock-conf"].hide();
    },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.fk_all_module_id;
      this.JOBSERIES = item.JobNo;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    handleJobClick(jobNo, item) {
      console.log('item=>', item)
      // Perform navigation or any other action for the clicked job number
      // airCCImpConsol,airTPTImpConsol,airTPTExportConsol,airCCExportConsol
      if (this.$route.path == '/airImport/viewAirTPT' && item.air_ct_transport_type == 'Export') {
        this.$router.push({
          path: "/airFreight/airTPTExportConsol/" + item.fk_all_module_id + "/" + item.air_ct_id,
        });
      } else if (this.$route.path == '/airImport/viewAirCC' && item.air_ct_transport_type == 'Export') {
        this.$router.push({
          path: "/airFreight/airCCExportConsol/" + item.fk_all_module_id + "/" + item.air_ct_id,
        });
      }
      else if (this.$route.path == '/airImport/viewAirTPT' && item.air_ct_transport_type == 'Import') {
        this.$router.push({
          path: "/airFreight/airTPTImpConsol/" + item.fk_all_module_id + "/" + item.air_ct_id,
        });
      } else if (this.$route.path == '/airImport/viewAirCC' && item.air_ct_transport_type == 'Import') {
        this.$router.push({
          path: "/airFreight/airCCImpConsol/" + item.fk_all_module_id + "/" + item.air_ct_id,
        });
      } else {
        this.$router.push({
          path: "/airFreight/airCCExportConsol/" + item.fk_all_module_id + "/" + item.air_ct_id,
        });
      }


    },
    clearFilter() {
      this.Filter = {
        job_no: "",
        commonFilter: "",
        clientFilter: "",
        airLineFilter: "",
        airportDepartureFilter: "",
        airportDestinationFilter: "",
        jobTypeFilter: "",
        clientFilter: "",
        transportFilter: "",
        createdByFilter: "",
        isShipmentFilter: 2,
        isActiveFilter: 1,
        isDeletedFilter: 0,
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },

    getAllTPTCCAirList(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.getAirList = [];
      if (type == "Normal") {
        this.isLoading = true;
      }

      this.Filter.perPage = this.pagination.perPage;
      this.Filter.currentPage = CURRENT;
      this.Filter.fromSearch = SEARCH;
      this.Filter.pageSize = this.pagination.perPage;
      this.Filter.page = parseInt(pageNumber) -1;

      NodeLockPannelService.getAllAirList(this.Filter)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (type == "Excell") {
              if (data.data.length > 0) {
                this.totalData = data.meta.totalAirExpImps;
                this.getAirList = data.data;
              }
              this.ExcelBtnName = "Export As Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.data.length > 0) {
                this.totalData = data.meta.totalAirExpImps;
                this.getAirList = data.data;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getAirList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() { },
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllTPTCCAirList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getAllTPTCCAirList("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getAllTPTCCAirList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getAllTPTCCAirList("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>
<style>
.job-no {
  color: #007bff;
  text-decoration: none;
  font-weight: bold;
  position: relative;
  transition: color 0.3s, transform 0.3s;
}

.job-no:hover {
  color: #0056b3;
  transform: scale(1.1);
}

.job-no:after {
  content: "";
  display: block;
  width: 0;
  height: 2px;
  background: #007bff;
  transition: width 0.3s;
  position: absolute;
  bottom: 0;
  left: 0;
}

.job-no:hover:after {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// viewAirCCTPT.vue?55e34504